export const HEADLIGHT_TYPE_SEPARATOR = ' + '

const HTML_ENTITIES = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
}

export function escapeHtml(value) {
  return String(value ?? '').replace(/[&<>"']/g, char => HTML_ENTITIES[char])
}

export function headlightTypeNames(types) {
  return (Array.isArray(types) ? types : [])
    .map(type => (typeof type?.name === 'string' ? type.name.trim() : ''))
    .filter(Boolean)
}

export function joinHeadlightTypeNames(types) {
  return headlightTypeNames(types).join(HEADLIGHT_TYPE_SEPARATOR)
}

export function cartLineHeadlightLabel(orderVariant) {
  return (
    joinHeadlightTypeNames(orderVariant?.shared_bulb?.headlight_types) ||
    orderVariant?.metadata?.headlight_type_name ||
    null
  )
}

export function isSharedBulbSpare(orderVariant) {
  return orderVariant?.shared_bulb?.is_spare === true
}

export function isSharedBulbDuplicate(orderVariant) {
  const sharedBulb = orderVariant?.shared_bulb
  if (!sharedBulb || sharedBulb.is_spare === true) return false

  return (
    sharedBulb.duplicate_of !== null && sharedBulb.duplicate_of !== undefined
  )
}

export function sharedBulbDuplicateParams(orderVariant) {
  const sharedBulb = orderVariant?.shared_bulb

  return {
    vehicle: orderVariant?.metadata?.vehicle_name || null,
    socket: sharedBulb?.headlight_category?.name || '',
    types: joinHeadlightTypeNames(sharedBulb?.headlight_types),
  }
}

export function sharedBulbConflictOf(error) {
  if (error?.response?.status !== 409) return null

  const conflict = error.response.data?.shared_bulb_conflict

  return conflict && typeof conflict === 'object' ? conflict : null
}

export function sharedBulbConflictParams(conflict) {
  return {
    socket: conflict?.headlight_category?.name || '',
    existing: conflict?.existing_headlight_type?.name || '',
    type: conflict?.headlight_type?.name || '',
    vehicle:
      typeof conflict?.vehicle_name === 'string'
        ? conflict.vehicle_name.trim()
        : '',
  }
}

export function sharedBulbConflictMessage(conflict, translate) {
  const params = sharedBulbConflictParams(conflict)

  return translate(
    params.vehicle
      ? 'mixins.cartMixin.sharedBulbConflictMessage'
      : 'mixins.cartMixin.sharedBulbConflictMessageWithoutVehicle',
    params
  )
}

export function orderTokenOf(body) {
  const token = body?.order?.token

  return typeof token === 'string' && token ? token : null
}

export function choosesSpareKit(choice) {
  return choice === false
}

export function withSharedBulbSpare(metadata) {
  return { ...(metadata || {}), shared_bulb_spare: true }
}

export function productSharedBulbs(sharedBulbs) {
  return (Array.isArray(sharedBulbs) ? sharedBulbs : [])
    .map(sharedBulb => {
      const names = headlightTypeNames(sharedBulb?.headlight_types)

      return {
        id: sharedBulb?.headlight_category?.id ?? null,
        socket: sharedBulb?.headlight_category?.name || '',
        names,
        label: names.join(HEADLIGHT_TYPE_SEPARATOR),
      }
    })
    .filter(
      entry => entry.id !== null && entry.socket && entry.names.length >= 2
    )
}

export function sharedBulbSpecification(entry, name) {
  return {
    id: `dual-function-${entry.id}`,
    specification: { name },
    value: entry.label,
    count: entry.names.length,
    dualFunction: true,
  }
}

export function sharedBulbQuestion(entry, translate) {
  return {
    id: `shared-bulb-${entry.id}`,
    question: translate('mixins.productMixin.sharedBulbQuestion', {
      socket: entry.socket,
      types: entry.label,
    }),
    answer: translate('mixins.productMixin.sharedBulbAnswer', {
      socket: escapeHtml(entry.socket),
      types: escapeHtml(entry.label),
    }),
  }
}
